import {
    REALTIME_CONNECTION_CONNECTED,
    REALTIME_CONNECTION_DISCONNECTED,
    REALTIME_CONNECTION_AUTHENTICATING,
    REALTIME_CONNECTION_AUTHENTICATED,

    VALIDATE_REAL_TIME_REQUEST_PARAMS,
    VALIDATE_REAL_TIME_REQUEST_PARAMS_SUCCESS,
    VALIDATE_REAL_TIME_REQUEST_PARAMS_FAILED,

    GET_REAL_TIME_DATA,
    GET_REAL_TIME_DATA_SUCCESS,
    GET_REAL_TIME_DATA_FAILED,
    ALERT_MSG
} from "constants/ActionTypes";

export const realtime_connection_connected = (payload) => ({
    type: REALTIME_CONNECTION_CONNECTED,
    payload
})

export const realtime_connection_disconnected = (payload) => ({
    type: REALTIME_CONNECTION_DISCONNECTED,
    payload
})

export const realtime_connection_authenticating = (payload) => ({
    type: REALTIME_CONNECTION_AUTHENTICATING,
    payload
})

export const realtime_connection_authenticated = (payload) => ({
    type: REALTIME_CONNECTION_AUTHENTICATED,
    payload
})

export const validate_real_time_request_params = (payload) => ({
    type: VALIDATE_REAL_TIME_REQUEST_PARAMS,
    payload
})

export const validate_real_time_request_params_success = (payload) => {
    return ({
        type: VALIDATE_REAL_TIME_REQUEST_PARAMS_SUCCESS,
        payload
    })
}

export const validate_real_time_request_params_failed = (payload) => ({
    type: VALIDATE_REAL_TIME_REQUEST_PARAMS_FAILED,
    payload
})

export const get_real_time_data = (payload) => ({
    type: GET_REAL_TIME_DATA,
    payload
})

export const get_real_time_data_success = (payload) => {
    return ({
        type: GET_REAL_TIME_DATA_SUCCESS,
        payload
    })
}

export const get_real_time_data_failed = (payload) => ({
    type: GET_REAL_TIME_DATA_FAILED,
    payload
})
export const alert_msg_action = (payload) => {
    return ({
        type: ALERT_MSG,
        payload
    })
}
